import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@services/authentication/authentication.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return true;
    //if (this.authenticationService.accessTokenExists()) {
    //  if (this.authenticationService.isAccessTokenValid()) {
    //    return true;
    //  }
    //}

    //this.authenticationService.logout();
    //this.router.navigate(['/auth/login']);
    //return false;
  }
}
